import { UseMutationOptions, useQueryClient } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import {
  AdminUpdateBuyerListSharingMutation,
  AdminUpdateBuyerListSharingMutationVariables,
} from "lib/generated/app-service-gql/graphql";
import { inferEnumType } from "lib/types/graphQLEnums";
import { useGraphQlMutation } from "../../useGraphQlClient";

const adminUpdateBuyerListSharingMutation = graphql(`
  mutation adminUpdateBuyerListSharing($input: AdminUpdateBuyerListSharingInput!) {
    adminUpdateBuyerListSharing(input: $input) {
      id
      name
      sharingType
    }
  }
`);

type UpdateSharingParams = { buyerListGuid: string; sharingType: "TEAM" | "PRIVATE" };

export function useAdminUpdateBuyerListSharing(
  options?: UseMutationOptions<
    AdminUpdateBuyerListSharingMutation,
    unknown,
    AdminUpdateBuyerListSharingMutationVariables,
    unknown
  >,
) {
  const queryClient = useQueryClient();
  const { mutate: innerMutate, ...rest } = useGraphQlMutation(adminUpdateBuyerListSharingMutation, {
    ...options,
    onSuccess: (data, variables, context) => {
      void queryClient.invalidateQueries(["buyerLists"]);
      void queryClient.invalidateQueries(["buyerList", variables.input.id]);
      options?.onSuccess?.(data, variables, context);
    },
  });
  return {
    ...rest,
    mutate: ({ buyerListGuid, sharingType }: UpdateSharingParams) =>
      innerMutate({ input: { id: buyerListGuid, sharingType: inferEnumType(sharingType) } }),
  };
}
